import React from 'react';
import { withRouter } from 'react-router-dom';
import imgEditarClave from 'assets/images/usuario/editar-clave.svg';
import Divider from '@mui/material/Divider';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import ButtonComponent from 'components/design-system/Button/Button';
import LegalAcceptanceModal from 'components/LegalAcceptanceModal/LegalAcceptanceModal';
import ContrasenaCampos from '../Contrasena/ContrasenaCampos';
import { Form, Formik } from 'formik';
import { schemaContrasena } from '../Contrasena/schema/schemaContrasena';
import { useOlvidoContrasena } from './hooks/useOlvidoContrasena';
import useLegalAcceptance from 'hooks/useLegalAcceptance';
import { Alerta, AlertaError } from 'utils/Alertas';

const OlvidoContrasenaFormik = () => {
  const { handleOnSubmit, openRedirect, handleClickCloseRedirect } =
    useOlvidoContrasena();
  const {
    open,
    handleClose,
    handleAccept,
    values,
    handleChange,
    puedeContinuar,
    handleLogout,
    isProcessing
  } = useLegalAcceptance('forgot', { onAccepted: handleClickCloseRedirect }); // Callback al aceptar la legalidad
  // se ocupa onAccept del modal para cerrar el modal de aceptación legal

  return (
    <section className="w-full bg-gradient-to-b from-[#EFF5F4] to-white">
      <div className="px-4 md:container md:mx-auto">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 pt-10">
            <div className="mb-4">
              <Heading type="h3" className="mb-0">
                Cambiar contraseña
              </Heading>
              <Text className="mb-0">
                Establece una nueva contraseña para el inicio de sesión
              </Text>
            </div>

            <div className="bg-white rounded shadow-md p-5 mb-5">
              <Formik
                initialValues={{
                  passwordActual: '',
                  password: '',
                  confirmarPassword: '',
                  validacionPassword: [
                    'largo',
                    'numero',
                    'minuscula',
                    'mayuscula',
                    'caracter'
                  ]
                }}
                validateOnMount={false}
                validationSchema={schemaContrasena}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={async (values, { resetForm }) => {
                  try {
                    await handleOnSubmit(values, resetForm);
                  } catch (error) {
                    console.error('Error al actualizar la contraseña', error);
                    const codigo = error?.response?.data?.error?.codigo;
                    if (codigo) {
                      Alerta(codigo);
                    } else {
                      AlertaError(
                        'La contraseña no se ha podido actualizar, vuelve a intentarlo y si el problema persiste comunicaté con el administrador.'
                      );
                    }
                  }
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  setFieldTouched,
                  isSubmitting,
                  handleChange,
                  setFieldValue
                }) => (
                  <Form id="contrasena">
                    <div className="grid grid-cols-12 gap-4">
                      <div className="col-span-12 md:col-span-3 mx-auto">
                        <img src={imgEditarClave} alt="Cambiar contraseña" />
                      </div>
                      <ContrasenaCampos
                        values={values}
                        handleChange={handleChange}
                        setFieldTouched={setFieldTouched}
                        setFieldValue={setFieldValue}
                        touched={touched}
                        errors={errors}
                        isSubmitting={isSubmitting}
                      />
                      <div className="col-span-12 my-2">
                        <Divider />
                      </div>
                      <div className="col-span-12 text-end">
                        <ButtonComponent
                          form="contrasena"
                          buttonType="submit"
                          isLoading={isSubmitting}
                          disabled={
                            Object.keys(errors).length === 0 && !isSubmitting
                              ? false
                              : true
                          }
                        >
                          {isSubmitting ? 'Guardando' : 'Cambiar contraseña'}
                        </ButtonComponent>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {/* Mostrar modal de aceptación legal si es necesario */}
      <LegalAcceptanceModal
        open={open}
        onClose={handleClose}
        onAccept={handleAccept}
        onLogout={handleLogout}
        isProcessing={isProcessing}
        values={values}
        onChange={handleChange}
        puedeContinuar={puedeContinuar}
      />
    </section>
  );
};

export default withRouter(OlvidoContrasenaFormik);
